import {owns} from './object';

const
    last = array => array[array.length - 1],

    each = (array, fn) => {
        for (let i = 0, length = array.length; i < length; i += 1) {
            fn(array[i], i, array);
        }
    },

    reduce = (array, fn, initial) => {
        each(array, (value, i, array) => {
            initial = fn(initial, value, i, array);
        });
        return initial;
    },

    map = (array, fn) => (
        reduce(
            array,
            (mapped, value, i, array) => {
                mapped.push(fn(value, i, array));
                return mapped;
            },
            [])),

    filter = (array, fn) => (
        reduce(
            array,
            (filtered, value, i, array) => {
                if (fn(value, i, array)) {
                    filtered.push(value);
                }
                return filtered;
            },
            [])),

    any = (array, fn) => {
        for (let i = 0, length = array.length; i < length; i += 1) {
            if (fn(array[i], i, array)) {
                return true;
            }
        }
        return false;
    },

    all = (array, fn) => {
        for (let i = 0, length = array.length; i < length; i += 1) {
            if (!fn(array[i], i, array)) {
                return false;
            }
        }
        return true;
    },

    index = (array, fn) => {
        for (let i = 0, length = array.length; i < length; i += 1) {
            if (fn(array[i], i, array)) {
                return i;
            }
        }
        return -1;
    },

    find = (array, fn) => array[index(array, fn)],

    mapfind = (array, fn) => {
        for (let i = 0, length = array.length; i < length; i += 1) {
            const value = fn(array[i], i, array);

            if (value !== undefined) {
                return value;
            }
        }
    },

    reversed = array => (
        array
        .slice()
        .reverse()),

    sorted = (array, compare) => (
        array
        .slice()
        .sort(compare)),

    unique = values => {
        const seen = {};

        return (
            reduce(
                values,
                (unique, value) => {
                    if (!owns(seen, value)) {
                        seen[value] = true;
                        unique.push(value);
                    }
                    return unique;
                },
                []));
    },

    generate = (count, fn) => {
        const values = [];

        for (let i = 0; i < count; i += 1) {
            values.push(fn(i));
        }
        return values;
    };

export {
    last,
    each,
    reduce,
    map,
    filter,
    any,
    all,
    index,
    find,
    mapfind,
    reversed,
    sorted,
    unique,
    generate
};
